// live-prices.js
(function () {
  function formatMoneyFromCents(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value);
    } catch (e) {
      return '$' + value.toFixed(2);
    }
  }

  function findTableColumnIndex(table, headerText) {
    var ths = table.querySelectorAll('thead th, thead td');
    for (var i = 0; i < ths.length; i++) {
      if (ths[i].textContent.trim().toLowerCase() === headerText.toLowerCase()) {
        return i;
      }
    }
    return -1;
  }

  function collectRows(table) {
    var rows = [];
    var tbodies = table.tBodies;
    for (var i = 0; i < tbodies.length; i++) {
      for (var j = 0; j < tbodies[i].rows.length; j++) {
        rows.push(tbodies[i].rows[j]);
      }
    }
    return rows;
  }

  function getHandleForRow(row) {
    // Look for Shop Now button in the last cell
    var shopLink = row.querySelector('td:last-child a[href]');
    if (shopLink) {
      var m = shopLink.getAttribute('href').match(/\/products\/([^\/?#]+)/i);
      if (m) {
        return m[1].toLowerCase();
      } else {
        return null; // Shop button is not a product
      }
    }
    return null;
  }

  function fetchProduct(handle, cache) {
    if (cache.has(handle)) return cache.get(handle);
    var p = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Fetch failed for ' + handle);
        return r.json();
      })
      .catch(function (err) {
        console.warn('[live-prices] ' + err.message);
        return null;
      });
    cache.set(handle, p);
    return p;
  }

  function updatePriceCell(cell, productJson) {
    if (!productJson || !productJson.variants || !productJson.variants.length) return;
    var variant = productJson.variants[0]; // default/first variant
    if (!variant || !variant.price) return;

    // safeguard: don't touch if fallback was 0.00
    var fallback = (cell.textContent || '').trim();
    if (fallback === '$0.00' || fallback === '0.00' || fallback === '0') {
      return;
    }

    var price = variant.price;
    cell.innerHTML = '<span class="live-price">' + formatMoneyFromCents(price) + '</span>';
    cell.setAttribute('data-live', 'true');
  }

  function run() {
    var tables = document.querySelectorAll('table');
    if (!tables.length) return;

    tables.forEach(function (table) {
      var priceIndex = findTableColumnIndex(table, 'Price');
      if (priceIndex === -1) return;

      var rows = collectRows(table);
      if (!rows.length) return;

      var rowData = [];
      rows.forEach(function (row) {
        if (!row.cells || row.cells.length <= priceIndex) return;
        var priceCell = row.cells[priceIndex];

        // Already handled?
        if (priceCell.hasAttribute('data-handle')) return;

        // Rule: skip if cell shows $0.00
        var fallback = (priceCell.textContent || '').trim();
        if (fallback === '$0.00' || fallback === '0.00' || fallback === '0') {
          return;
        }

        var handle = getHandleForRow(row);
        if (!handle) {
          // no product link → leave fallback alone
          return;
        }

        rowData.push({ cell: priceCell, handle: handle });
      });

      // Deduplicate handles
      var uniqueHandles = Array.from(new Set(rowData.map(function (r) { return r.handle; })));

      var cache = new Map();
      Promise.all(uniqueHandles.map(function (h) { return fetchProduct(h, cache).then(function (j) { return { h: h, j: j }; }); }))
        .then(function (results) {
          var byHandle = {};
          results.forEach(function (r) { byHandle[r.h] = r.j; });

          rowData.forEach(function (r) {
            updatePriceCell(r.cell, byHandle[r.handle]);
          });
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
